'use client';

import { useUser } from '@auth0/nextjs-auth0/client';
import Script from 'next/script';
import { useEffect, useState } from 'react';

// Taken from https://developers.heap.io/reference/client-side-apis-overview#typescript-type-definitions
// and modified a litte.
interface Heap {
  track: (event: string, properties?: object) => void;
  identify: (identity: string) => void;
  resetIdentity: () => void;
  addUserProperties: (properties: object) => void;
  addEventProperties: (properties: object) => void;
  removeEventProperty: (property: string) => void;
  clearEventProperties: () => void;
  appid: string;
  userId: string;
  identity: string | null;
  config: unknown;
}

declare global {
  interface Window {
    heap: Heap;
  }
}

export interface HeapAnalyticsProps {
  heapId: string;
}

export const HeapAnalytics = ({ heapId }: HeapAnalyticsProps) => {
  const { user } = useUser();
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (user && user.email && typeof window !== 'undefined' && typeof window['heap'] !== 'undefined') {
      window.heap.identify(user.email);
      window.heap.addUserProperties({ name: user.name });
    }
  }, [scriptLoaded, user]);

  const scriptReady = () => {
    if (window.heap) {
      setScriptLoaded(true);
    }
  };

  if (heapId === '') {
    return null;
  }

  return (
    <Script
      id="heap-analytics"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
      window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
      heap.load("${heapId}");
      `,
      }}
      onReady={scriptReady}
    />
  );
};
